
export const colors ={
    dark: '#0B0B1E',
    red: '#D41F0B',
};
